var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBorn = function SvgBorn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#born_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#born_svg__b)",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 4a2.997 2.997 0 0 0-5.92-.667 6.909 6.909 0 0 0-8.16 0A2.997 2.997 0 1 0 9 7c.112-.005.223-.016.333-.033A6.888 6.888 0 0 0 9 9a7 7 0 1 0 14 0 6.885 6.885 0 0 0-.333-2.033c.111.017.223.028.336.033A3 3 0 0 0 26 4ZM9.703 23.067A6.985 6.985 0 0 1 9 20c.001-.377.028-.753.079-1.127M19.067 26.297a7.02 7.02 0 0 1-6.123 0M22.92 18.863c.051.377.078.756.08 1.137a6.985 6.985 0 0 1-.703 3.067",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 31a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM23 31a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM9.079 18.873 3.299 16.3a3 3 0 0 1 2.441-5.482M22.921 18.873l5.78-2.574a3 3 0 1 0-2.434-5.482",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 8.5a.5.5 0 0 1 0-1M13 8.5a.5.5 0 0 0 0-1M19 8.5a.5.5 0 0 1 0-1M19 8.5a.5.5 0 0 0 0-1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "born_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "born_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgBorn;